<template>
  <v-list-item-title class="d-flex align-center">
    <div>{{ menuItem.name ? $t(menuItem.name) : "" }}</div>
    <v-spacer />
    <v-chip
      v-if="assignedTasksCount > 0"
      class="chip ml-1 white--text"
      color="primaryChip"
      small
      data-qa="assigned_tasks_count"
      >{{ assignedTasksCount }}</v-chip
    >
    <v-chip
      v-if="assignedOverdueTasksCount > 0"
      class="chip ml-1 white--text"
      color="errorChip"
      small
      data-qa="overdue_tasks_count"
      >{{ assignedOverdueTasksCount }}</v-chip
    >
  </v-list-item-title>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { computed, defineComponent } from "vue";
import type { MenuItem } from "@/app/ui/navigation/types";
import tasksStore from "@/store/modules/tasksStore";

export default defineComponent({
  name: "TasksMenuItem",
  props: {
    menuItem: {
      type: Object as PropType<MenuItem>,
      required: true,
    },
  },
  setup() {
    return {
      assignedTasksCount: computed(() => tasksStore.state.assignedTasksCount),
      assignedOverdueTasksCount: computed(
        () => tasksStore.state.assignedOverdueTasksCount
      ),
    };
  },
});
</script>

<style lang="sass" scoped>
.chip
  font-size: 14px
  font-weight: 700
  height: auto!important
  padding: 0 8px
</style>
